import { ID } from 'containers/constants'
import { isEmpty } from 'utils'

export const nofitySfChat = (message, origin) => {
  const chatIframeEl = document.getElementsByName(ID.LIVE_AGENT_CHAT_FRAME)[0]
  if (!isEmpty(chatIframeEl)) chatIframeEl.contentWindow.postMessage(message, origin)
}



// WEBPACK FOOTER //
// ./src/utils/postMessage.js